import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import FileLines from 'components/Icons/FileLines';
import useFormikHandler from 'screens/Integrations/hooks/useFormikHandler';
import StepCard from 'screens/Integrations/components/StepCard';
import StepHeader from 'screens/Integrations/components/StepHeader';

import UnitListItem from './components/UnitListItem';
import { sortInvoices } from '../../helpers';

const AgVendUnitList = ({
  invoices,
  isLoading,
  unMatchedCount,
  onChangeUnit
}) => {
  const { excludedProductsIds } = useFormikHandler();
  const sortedInvoices = useMemo(() => {
    return sortInvoices(
      invoices
        .map(invoice => ({
          ...invoice,
          products: invoice.products.filter(
            product => !excludedProductsIds?.includes(product.id)
          )
        }))
        .filter(invoice => invoice.products?.length)
    );
  }, [invoices, excludedProductsIds]);
  return (
    <StepCard>
      <div
        className="flex flex-col w-full mb-5"
        id="retailers-match-top-header"
      >
        <StepHeader
          title="Match Units of Measure"
          description="Match units of measure from your retailer invoices to available Cropwise Financials units."
          isMatchCountVisible
          isLoading={isLoading}
          unmatchCount={unMatchedCount}
        />
      </div>
      {sortedInvoices?.map(invoice => (
        <div className="mt-2" key={invoice.id}>
          <div className="flex items-center">
            <div className="flex flex-row items-center text-xl font-semibold text-gray-800">
              <FileLines color="#696F88" />
              <span className="ml-2 text-gray-800" data-testid="retailer-name">
                {invoice.invoiceNumber}
              </span>
            </div>
          </div>
          <div className="w-full mb-5 overflow-y-auto">
            {invoice.products?.map(product => (
              <UnitListItem
                key={product.retailerId || product.vendorId}
                invoice={invoice}
                product={product}
                cwfProduct={product.cwfProduct}
                matchedUnit={product.unitMatched}
                handleChange={onChangeUnit}
              />
            ))}
          </div>
        </div>
      ))}
    </StepCard>
  );
};

AgVendUnitList.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      invoiceNumber: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          retailerId: PropTypes.string,
          vendorId: PropTypes.string,
          productName: PropTypes.string,
          unitMatched: PropTypes.boolean
        })
      )
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  unMatchedCount: PropTypes.number.isRequired,
  onChangeUnit: PropTypes.func.isRequired
};

export default AgVendUnitList;
